import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'formWizard',
  setup(__props) {

const shippingForm = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard/shippingForm.vue"))
const simpleWizard = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard/simpleWizard.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Layout",
      title: "Form Wizard"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(simpleWizard)),
        _createVNode(_unref(shippingForm))
      ])
    ])
  ], 64))
}
}

})